<template>
  <b-container>
    <b-row v-if="fetching" align-h="center">
      <b-spinner v-if="fetching" label="Fetching ultimate learning outcome" variant="dark" />
    </b-row>

    <b-row v-else align-h="center" class="m-0">
      <b-col cols="8">
        <base-bread-crumb :items="breadcrumbs" />

        <h5 v-if="learningUnit" class="display-4 mt-1 mb-5 font-weight-bold">
          {{ learningUnit.name }}
        </h5>

        <h5 class="font-weight-bold mb-4">
          {{ pageTitle }}
        </h5>

        <form-learning-outcome
          :id="id"
          :learning-unit-id="learningUnitId"
          :form-data="learningUnit.ultimate_learning_outcome"
          :api-provider="ultimateLearningOutcomeProvider"
          class="form__ultimate-lo"
          @submit="onSubmit"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { LearningUnit } from '@/models/LearningUnit';
import { LearningOutcome } from '@/models/LearningOutcome';
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import FormLearningOutcome from '@/components/LearningOutcome/FormLearningOutcome';

export default {
  components: {
    BaseBreadCrumb,
    FormLearningOutcome
  },

  data() {
    return {
      fetching: false
    };
  },

  computed: {
    learningUnitId() {
      return this.$route.params.learningUnitId;
    },

    learningUnit() {
      return LearningUnit.query().with('ultimate_learning_outcome').find(this.learningUnitId);
    },

    id() {
      return this.$route.params.id;
    },

    previousPage() {
      return this.$route.query.previousPath;
    },

    breadcrumbs() {
      const { learningUnitId, previousPage = '' } = this;

      const re = new RegExp('/design-planning/info');
      const isDesignPage = previousPage.match(re);

      const route =
        previousPage && isDesignPage && isDesignPage.length
          ? {
              path: this.$route.query.previousPath
            }
          : {
              name: 'design-planning/info',
              params: {
                learningUnitId
              }
            };

      return [
        {
          key: 'design-and-planning',
          name: 'Design and planning',
          to: {
            name: 'design-planning'
          }
        },
        {
          key: 'learning-unit-info',
          name: this.learningUnit?.name || '',
          to: route
        },
        {
          key: 'manage-learning-outcome',
          name: this.pageTitle,
          active: true
        }
      ];
    },

    pageTitle() {
      return `${this.id ? 'Edit' : 'Create'} an ultimate learning outcome`;
    }
  },

  watch: {
    learningUnitId: {
      immediate: true,
      handler: 'fetch'
    }
  },

  methods: {
    async fetch(learningUnitId) {
      let promise;

      if (learningUnitId) {
        try {
          this.fetching = true;

          promise = await LearningUnit.api().fetchByLearningUnitId(learningUnitId);
        } catch (error) {
          this.$toast.error('Cannot load learning unit data, please try again');
        } finally {
          this.fetching = false;
        }
      }

      return promise;
    },

    async ultimateLearningOutcomeProvider(data) {
      let promise;

      if (this.id) {
        promise = await LearningOutcome.api().updateUltimateLearningOutcome(this.id, data);
      } else {
        promise = await LearningOutcome.api().createUltimateLearningOutcome(
          this.learningUnitId,
          data
        );
      }

      return promise;
    },

    onSubmit() {
      console.log('onSubmit');
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>
